import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getMainClasses } from "../../../utils/userDetailsUtils";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import StudentSchedulePopup from "../../../../student/features/SchedulePopup/SchedulePopup";
import TeacherSchedulePopup from "../../../../teacher/features/SchedulePopup/SchedulePopup";
import scheduleImg from "../../../../assests/carouselWidget/schedual.png";

const ScheduleCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { user, userDetails, isStudent } = useSelector(state => state.auth);
    const [schedulePopupOpen, setSchedulePopupOpen] = useState(false);
    const SchedulePopup = isStudent ? StudentSchedulePopup : TeacherSchedulePopup;
    const mainClasses = isStudent ? undefined : getMainClasses(userDetails);

    const openSchedulePopup = (e) => {
        e?.stopPropagation();
        setSchedulePopupOpen(true);
    };

    return (
        <>
            <WidgetCarouselCard
                color="#C5D7E4"
                title={texts.scheduleMiniTitle}
                image={scheduleImg}
                imageAlt={texts.scheduleMiniTitle}
                onClick={openSchedulePopup}
            />
            {schedulePopupOpen && (
                <SchedulePopup
                    onClose={() => setSchedulePopupOpen(false)}
                    {...(mainClasses ? { mainClasses } : {})}
                />
            )}
        </>
    );
};

export default ScheduleCarouselWidget;
